import { PersonalSetting } from '@ardoq/api-types';
import { ConfirmResult, ModalSize, confirm } from '@ardoq/modal';
import { isDiscoverJourney } from 'canvas/isDiscoverJourney';
import { t } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { dispatchAction } from '@ardoq/rxbeach';
import { updatePersonalSetting } from 'streams/currentUser/actions';

export const confirmOpenNewDatasetOrSavedViewpointAndClosePreviousView =
  async ({
    origin,
    isSuppressConfirmDialog,
  }: {
    origin:
      | 'openNewDataset'
      | 'openViewpoint'
      | 'openWorkspacesInViewpointMode';
    isSuppressConfirmDialog: boolean;
  }) => {
    if (isSuppressConfirmDialog || isDiscoverJourney()) return true;

    // i18nLocale$.state OK here: snapshot-at-open-time; @ardoq/modal renders confirm() body once and does not re-render on locale change
    const i18nLocale = i18nLocale$.state;
    const isViewpoint = origin === 'openViewpoint';
    const { rememberAction, confirmed } = (await confirm({
      title: isViewpoint
        ? t(
            i18nLocale,
            'viewpointNavigator:confirmOpenNew.titleViewpoint',
            'Open Viewpoint?'
          )
        : t(
            i18nLocale,
            'viewpointNavigator:confirmOpenNew.titleDataset',
            'Open new dataset?'
          ),
      text: (
        <>
          <p>
            {t(
              i18nLocale,
              'viewpointNavigator:confirmOpenNew.body1',
              'This will close all currently opened workspaces or datasets.'
            )}
          </p>
          <p>
            {t(
              i18nLocale,
              'viewpointNavigator:confirmOpenNew.body2',
              'Remember to save datasets you need as Viewpoints or presentation slides before they are closed.'
            )}
          </p>
        </>
      ),
      confirmButtonTitle: isViewpoint
        ? t(
            i18nLocale,
            'viewpointNavigator:confirmOpenNew.confirmViewpoint',
            'Open Viewpoint'
          )
        : t(
            i18nLocale,
            'viewpointNavigator:confirmOpenNew.confirmDataset',
            'Open new dataset'
          ),
      confirmButtonClickId: 'open-dataset-modal-confirm',
      confirmButtonDataTestId: 'open-dataset-modal-confirm',
      cancelButtonTitle: t(
        i18nLocale,
        'viewpointNavigator:confirmOpenNew.cancelButton',
        'Cancel'
      ),
      cancelButtonClickId: 'open-dataset-modal-cancel',
      cancelButtonDataTestId: 'open-dataset-modal-cancel',
      showRememberActionCheckbox: true,
      rememberActionCustomCheckboxText: t(
        i18nLocale,
        'viewpointNavigator:confirmOpenNew.rememberAction',
        "Don't show this again"
      ),
      modalSize: ModalSize.S,
    })) as ConfirmResult;

    if (rememberAction) {
      dispatchAction(
        updatePersonalSetting({
          personalSetting: PersonalSetting.DONT_SHOW_OPEN_DATASET_CONFIRMATION,
          newValue: true,
        })
      );
    }

    return confirmed;
  };
